import { apiHubBaseUrl, request } from '@/libs/api-request'

export function getCardPvData (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_pv_summary'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getCardSessionData (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_session_summary'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getListData (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSitemapTree (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_sitemap_tree'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function createSitemapSchemaReport (params, force = true) {
  let url = apiHubBaseUrl() + '/v1/geo/schema/create_sitemap_report'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getDetail (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_detail'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function makeFavorite (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/update_bookmark'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getBookmarkList (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/journey/get_bookmark_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getBookmarkCount (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_bookmark_count'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function updateBookmark (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/update_bookmark'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getPastPvCount (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/ranking/get_past_pv_count'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
